import type { KpiGridBlock } from '../types/report'
import styles from './blocks.module.css'

export function KpiGrid({ block }: { block: KpiGridBlock }) {
  return (
    <div className={styles.kpiGrid}>
      {block.items.map((item, i) => (
        <div className={styles.kpiCell} key={i}>
          <div className={styles.kpiValue}>
            {item.value}
            {item.unit ? <span className={styles.kpiUnit}>{item.unit}</span> : null}
          </div>
          <div className={styles.kpiLabel}>{item.label}</div>
        </div>
      ))}
    </div>
  )
}
